export default __webpack_public_path__ + "static/media/181.b9f3cf7f.png";